import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TechnicalSupportJobsGhazi = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Technical Support Jobs in Ghaziabad  | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Explore the latest technical support jobs in Ghaziabad  NCR. Find openings for desktop support engineers, IT helpdesk staff, and technical support executives. Apply for fresher and experienced roles now!"
        />
        <meta
          name="keywords"
          content="technical support jobs in Ghaziabad , IT support jobs in Ghaziabad  NCR, desktop support jobs Ghaziabad , helpdesk jobs Ghaziabad , hardware engineer jobs Ghaziabad , tech support jobs Ghaziabad , customer support engineer Ghaziabad , IT support executive jobs Ghaziabad , fresher technical support jobs Ghaziabad "
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/technicalsupport-jobs-in-ghaziabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Technical Support Jobs in Ghaziabad  – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for <strong>technical support jobs in Ghaziabad  NCR</strong>? Find
          hundreds of opportunities in IT support, helpdesk management, network
          troubleshooting, and hardware maintenance. Whether you are a fresher
          or an experienced engineer, apply to top companies hiring now.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Technical Support Professionals
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>HCL Technologies</li>
          <li>Tech Mahindra</li>
          <li>Concentrix</li>
          <li>Wipro</li>
          <li>Infosys BPM</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Technical Support Job Roles in Ghaziabad 
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Technical Support Executive Jobs in Ghaziabad </li>
          <li>Desktop Support Engineer Jobs in Ghaziabad </li>
          <li>IT Helpdesk Jobs in Ghaziabad  NCR</li>
          <li>Customer Support Engineer Jobs in Ghaziabad </li>
          <li>Network Support Jobs in Ghaziabad </li>
          <li>Hardware & Software Support Jobs in Ghaziabad </li>
          <li>Technical Support Analyst Jobs in Ghaziabad </li>
          <li>Remote Technical Support Jobs in Ghaziabad </li>
          <li>Voice Process Technical Support Jobs in Ghaziabad </li>
          <li>Non-Voice Technical Support Jobs in Ghaziabad </li>
        </ul>

        <p className="text-gray-600">
          Begin your career with <strong>jobsindelhincr.in</strong> — your
          trusted platform to find verified{" "}
          <strong>technical support job openings</strong> in Ghaziabad . Apply
          directly to companies and start your IT support career today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default TechnicalSupportJobsGhazi;
